import { useSnackbar } from "notistack";
import { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  createApiServices as createApiServicesService,
  deleteApiServices as deleteApiServicesService, 
  getApiServices
} from "../../services/tenant/api-services.service";
import { validate } from "../../utils";
import { handlerErrorV2 } from "../../utils/errors";
import { updateApiServicesList, updateApiServicesListMethod } from "../../store/actions/tenant.actions";
import isEmpty from 'lodash/isEmpty';

const useApiServices = () => {
  const { enqueueSnackbar } = useSnackbar()

  const dispatch = useDispatch();
  const [isLoadingList, setIsLoadingList] = useState(false);
  const [errors, setErrors] = useState({});

  const fetchApiServices = useCallback(async () => {
    setIsLoadingList(true);
    try {
      const response = await getApiServices();
      dispatch(updateApiServicesList(response?.data || []));
    } catch (error) {
      setErrors({ message: error.message || 'An error ocurred'});
    } finally {
      setIsLoadingList(false);
    }
  }, []);

  useEffect(() => {
    fetchApiServices();
  }, []);

  const validateForm = (form) => {
    const fieldRules = {
      permissions: 'required',
    }

    const errors = validate(fieldRules, form)
    if (!isEmpty(errors)) {
      return { error: true, ...errors }
    }

    return { error: false }
  }

  const createApiServices = async (form = {}) => {
    const result = validateForm(form);
    if (result.error) {
      return result
    };

    try {
      const response = await createApiServicesService(form);
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        dispatch(updateApiServicesListMethod('POST', response.data));
        enqueueSnackbar('Credential created successfully', { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    }
  }

  const deleteApiServices = async (analyticsChartId) => {
    try {
      const response = await deleteApiServicesService(analyticsChartId);
      if (!response.data && response.error) {
        return { error: true, message: response.error.message || 'An error ocurred'}
      } else {
        dispatch(updateApiServicesListMethod('DELETE', analyticsChartId));
        enqueueSnackbar('Credential deleted successfully', { variant: 'success' })
        return { error: false }
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      return { error: true, message }
    }
  }

  return {
    errors,
    isLoadingList,
    createApiServices,
    deleteApiServices
  }
};

export default useApiServices;